export default __webpack_public_path__ + "static/media/cdn.1277df64.png";